module.exports = __webpack_public_path__ + "img/comida-peruana.15fc5c18.jpg";